<template>
	<div class="search-box-wrapper">
		<div class="input-group">
            <div class="input-group-prepend">
                <div class="input-group-text mr-2"><i class="fas fa-search text-secondary"></i></div>
            </div>
			<input
				ref="searchInput"
				type="search"
				class="form-control"
				v-model="searchString"
				:placeholder="placeholder ? placeholder : $t('searchBox.placeholder')"
				@input="onInput"
				@blur="onBlur"
				@focus="onFocus"
				v-validate="required ? 'required':''"
				:name="'searchbox'+_uid"
				:data-vv-as="fieldName"
				autocomplete="off"
				@keydown="onKeyPress($event)"
				autofocus
			/>
			<i class="input-group-append fas fa-times text-secondary" @click="onClear" v-if="searchString"></i>
            <div class="input-group-append" v-if="!searchString">
                <button class="btn btn-link text-secondary"
                    :title="$t('upcomingEvents.participationRequestConfirmation')"
                    data-toggle="tooltip"
                    @click.stop="showFirst100">
                    <i class="fa fa-chevron-down"></i>
                </button>
            </div>
		</div>
		<span class="text-danger col-12" v-if="errors.has('searchbox' + _uid)">{{ errors.first('searchbox' + _uid) }}</span>
		<transition name="searchBoxTemplateAnimation" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
			<div class="template" v-if="showResultBody">
				<div v-if="searching" class="loader"></div>
				<div v-if="!searching && searchString.length < minLength" class="text-center text-danger">{{minLengthMessage}}</div>

				<div
					v-if="!searching && items.length == 0 && searchString.length >= minLength"
					class="template-no-items-found text-center text-danger"
				>{{ $t('searchBox.noItemsFound') }}</div>
				<div v-if="!searching && items.length > 0">
					<div
						class="template-item p-2"
						:class="{selected: (item.selected || selectedIndex == index)}"
						v-for="(item, index) of items"
						:key="'searchbox'+index"
						@click="itemClicked(item)"
						:data-id="item.id"
						:title="item.text"
					>{{ item.text }}</div>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
import _ from 'lodash';
export default {
	inject: ['$validator'],
	props: {
		placeholder: {
			type: String,
			default: undefined
		},
		apiUrl: {
			type: String,
			default: 'api/person/search'
		},
		value: {
			type: [String, Number],
			default: null
		},
		initialValueText: {
			type: String,
			required: false
		},
		minLength: {
			type: Number,
			default: 3
		},
		required: {
			type: Boolean,
			default: false
		},
		fieldName: {
			type: String
		},
        showAllUsersBtn: {
            type: Boolean,
            default() {
                return false;
            }
        }
	},
	data() {
		return {
			searchString: '',
			searching: false,
			items: [],
			showResultBody: false,
			selected: false,
			emited: false,
			selectedIndex: -1,
            showFirst: null
		};
	},
	methods: {
		onInput() {
			if (
				this.searchString &&
				this.searchString.length >= this.minLength
			) {
				this.search(this);
			}

			this.selected = false;
		},
        showFirst100() {
            this.showFirst = 100;
            this.search(this);
        },
		search: _.debounce(vm => {
			vm.items = [];
			vm.searching = true;
			vm.showResultBody = true;

            let url = `/${vm.apiUrl}?text=${vm.searchString}`;
            if (vm.showFirst) {
                url += `&showFirst=${vm.showFirst}`
            }

			vm.$http
				.get(url)
				.then(result => {
					vm.items = result.data;
				})
				.catch(error => {
					// TODO:
				})
				.then(() => {
                    vm.searching = false;
                    vm.showFirst = null;
                });
		}, 350),
		itemClicked(item) {
			this.selected = true;
			this.searchString = item.text;
			this.showResultBody = false;
			this.items = [];
			this.emited = true;
			this.$emit('input', item.id, item.text);
		},
		onClear() {
			this.searchString = '';
			this.showResultBody = false;
			this.items = [];
		},
		onBlur() {
			setTimeout(() => {
				this.showResultBody = false;

				if (!this.selected) {
					this.searchString = '';
					this.items = [];
				}
			}, 300);
		},
		onFocus() {
			if (!this.selected) {
				this.showResultBody = true;
			}
		},
		onKeyPress(e) {
			if (this.items.length) {
				if (e.keyCode === 40) {
					// Arrow down
					e.preventDefault();
					if (this.selectedIndex < this.items.length - 1) {
						this.selectedIndex++;
					}
				} else if (e.keyCode === 38) {
					// Arrow up
					e.preventDefault();
					if (this.selectedIndex > 0) {
						this.selectedIndex--;
					}
				} else if (e.keyCode === 13) {
					// Enter
					e.preventDefault();
					this.itemClicked(this.items[this.selectedIndex]);
				}
			}
		}
	},
	computed: {
		minLengthMessage() {
			return `Въведете поне ${this.minLength} символа`; // TODO
		}
	},
	mounted() {
		if (this.value) {
			let item = {
				id: this.value,
				text: this.initialValueText
			};

			this.items.push(item);
			this.searchString = this.initialValueText;
		}
	},
	watch: {
		value: function(newVal, oldVal) {
			if (this.emited) {
				this.emited = false;
				return;
			}

			if (newVal) {
				let item = {
					id: this.value,
					text: this.initialValueText
				};

				this.items.push(item);
				this.searchString = this.initialValueText;
			} else {
				this.items = [];
				this.searchString = '';
			}
		}
	}
};
</script>

<style scoped lang="scss">
.search-box-wrapper {
	position: relative;
	width: 100%;

	.input-group-append {
		align-self: center;
	}
}
.template {
	top: 36px;
	left: 0;
	width: 100%;
	max-height: 300px;
	position: absolute;
	background: white;
	z-index: 10;
	overflow-y: auto;
	box-shadow: 0px 1px 1px 0px lightgrey;
}

.template-item {
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
}

.template-item:hover {
	cursor: pointer;
	background: rgba(0, 150, 140, 0.2);
}

.template-item.selected {
	background: rgba(0, 150, 140, 0.2);
}
</style>
